import { API_URL, getHeaders } from "../../utils/contextHelpers";
import { api, buildQuery, request } from "./core";

export const getProductosByCriteria = api(
  "getProductosByCriteria",
  ({ tipo = "", familia = 0, descripcion = "", start = 0, length = 50 }) =>
    `${API_URL}productos?${buildQuery({
      tipo: String(tipo),
      familia: String(familia),
      descripcion: String(descripcion),
      start: String(start),
      length: String(length),
    })}`
);

export const getProductosByFamilia = api(
  "getProductosByFamilia",
  (idFamilia) => `${API_URL}familia/productos?id_familia=${idFamilia}`
);

export const grabarAtributoProducto = api(
  "grabarAtributoProducto",
  ({ codigo, atributo, descripcion, aplicacion, conversion }) =>
    `${API_URL}atributo_producto/grabar?${buildQuery({
      codigo: String(codigo),
      atributo: String(atributo),
      descripcion: String(descripcion),
      aplicacion: String(aplicacion),
      conversion: String(conversion ?? 1),
    })}`
);

export const asociarProducto = api(
  "asociarProducto",
  ({ codigo, familia, tipo }) =>
    `${API_URL}productos/asociar?${buildQuery({
      codigo: String(codigo),
      familia: String(familia),
      tipo: String(tipo),
    })}`
);

export const desasociarProducto = api(
  "desasociarProducto",
  ({ codigo, familia, tipo }) =>
    `${API_URL}productos/desasociar?${buildQuery({
      codigo: String(codigo),
      familia: String(familia),
      tipo: String(tipo),
    })}`
);

export const insertarFotoProducto = (formData) => {
  const headers = getHeaders();
  headers.delete("Content-Type");
  return request(`${API_URL}productos/foto`, {
    method: "POST",
    headers,
    body: formData,
  });
};

export const editarFotoProducto = (formData) => {
  const headers = getHeaders();
  headers.delete("Content-Type");
  return request(`${API_URL}productos/foto/update`, {
    method: "POST",
    headers,
    body: formData,
  });
};

export const eliminarFotoProducto = (id) =>
  api(
    "eliminarFotoProducto",
    () => `${API_URL}productos/foto/delete?${buildQuery({ id })}`
  )();

export const getFotosProductosByCodigo = api(
  "getFotosProductosByCodigo",
  (codigo) => `${API_URL}productos/foto?codigo=${codigo}`
);

export const UpdatePortada = api(
  "updatePortada",
  (id, codigo) => `${API_URL}/productos/foto/portada?id=${id}&codigo=${codigo}`
);

